import {
  Component,
  OnInit,
  ViewChild,
  Output,
  Input,
  EventEmitter,
  ElementRef
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';
import { AuthenticationService } from "src/app/services/authentication.service";
import { PetitionerService } from "src/app/services/petitioner.service";
import moment from 'moment';
import { i9 } from 'src/app/data/models/i9.model';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-i9-forms',
  templateUrl: './i9-forms.component.html',
  styleUrls: ['./i9-forms.component.scss'],animations: [
    trigger('rowExpansionTrigger', [
      state('void', style({
        transform: 'translateX(-10%)',
        opacity: 0
      })),
      state('active', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class I9FormsComponent implements OnInit {

  totalElementCount: number = 0;
  searchSubscription: Subscription;
  pageSizeOptions = [10, 20, 30];
  pageIndex: number = 0;//default
  pageSize: number = 10;//default
  searchText: string;
  totalVisits = 0;
  viewI9Form:boolean=false;
  viewfile
  beneficiaryList:i9[]=[]
  isFormGenerated:boolean=false;
  displayDialog:boolean = false;
  showLoader:boolean = false;
  pdfSrc = null;
  @ViewChild("search", { static: true }) search: ElementRef;

  payload:any =  {
    "pageNumber": 0,
    "pageSize": 10,
    "searchText": ""
  }


  constructor(  private authenticationService: AuthenticationService,
    private petitionerService: PetitionerService) { }


  ngOnInit(): void {
   this.loadI9BeneficiaryList();
   this.searchSetUp()
  }

  searchSetUp() {
    this.searchSubscription = fromEvent(this.search.nativeElement, 'keyup').pipe(
      map((event: any) => { return event.target.value; })
      , filter(res => res.length > 2)
      , debounceTime(1000)).subscribe((text: string) => {
        this.searchText = text.trim();
        this.loadI9BeneficiaryList();
      });
  }

  loadI9BeneficiaryList(){
    this.payload.searchText = this.searchText;
    this.payload.pageNumber = this.pageIndex + 1;
    this.payload.recordsPerPage = this.pageSize;
    this.petitionerService.getI9BeneficiaryList(this.payload).subscribe(res=>{
      // console.log(res)
      this.beneficiaryList = res['i9BenList'];
      this.totalElementCount = res['totalElementCount'];
    })
  }

  paginationEvent(event) {
    this.pageSize = event.rows;
    this.pageIndex = event.page;
    this.loadI9BeneficiaryList();
  }

  resetSearch(){
    this.searchText = '';
    this.loadI9BeneficiaryList();
  }


  showI9Form(beneficiary){
    this.petitionerService.getGeneratedI9Form(beneficiary['companyId'],beneficiary['i9FormId']).subscribe(res=>{
      this.pdfSrc = `${environment.docs}${res.fileDetails.path.replace('/var/imagility/uploads/', '')}`;
      window.open(this.pdfSrc, '_blank');
    })
  }

}
